import { AuthImg } from "@/components/AuthImg";
import { CameraOff } from "lucide-react";

/* THE PART'S MAIN PHOTO ON A JOB, A PICK OR A CART LINE (Batch 3b). `fileId` comes from the server's
   one definition — never a tag close-up or a number photo; none is said, never a broken square. */
export function LinePhoto({ fileId, alt = "", className = "w-10 h-10", testid }) {
  if (!fileId) {
    return (
      <span data-testid={testid ? `${testid}-none` : undefined} title="No overall photo yet"
        className={`${className} shrink-0 inline-flex items-center justify-center rounded border border-dashed border-slate-300 bg-slate-50 text-slate-300`}>
        <CameraOff className="w-4 h-4" />
      </span>
    );
  }
  return (
    <span data-testid={testid} className="shrink-0 inline-flex">
      <AuthImg fileId={fileId} thumb alt={alt} className={`${className} rounded object-cover border border-slate-200`} />
    </span>
  );
}
